var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageWarning16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Message/Warning16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconWarning16",
    transform: "translate(-405.000000, -132.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "04-Honeycomb-Foundation/icon/Message/Warning16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconWarning",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89177771,1.01348178 L13.7422709,12.5476339 C13.9921058,13.0401793 13.79535,13.6419975 13.3028046,13.8918323 C13.1626135,13.9629418 13.007633,14 12.8504385,14 L1.14945218,14 C0.597167432,14 0.149452181,13.5522847 0.149452181,13 C0.149452181,12.8428055 0.186510378,12.6878251 0.257619832,12.5476339 L6.10811302,1.01348178 C6.3579479,0.520936374 6.95976603,0.324180619 7.45231144,0.574015501 C7.64175872,0.67010926 7.79568395,0.824034495 7.89177771,1.01348178 Z",
    id: "Triangle",
    fill: "#F95200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Stroke",
    fill: "#FFFFFF",
    x: 6,
    y: 5,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Dot",
    fill: "#FFFFFF",
    x: 6,
    y: 10,
    width: 2,
    height: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWarning16);
export default __webpack_public_path__ + "static/media/messageWarning16.08983bec492bef6eeb834ed5ee67698f.svg";
export { ForwardRef as ReactComponent };